import { observer } from "mobx-react";
import { C_RMA_AVAILABLE_REASONS } from "../../../../../../models/User";
import { GroupedOption, SelectDropdownGrouped } from "../../../../../../components/inputs/select-dropdown-grouped/select-dropdown-grouped";
import { SelectDropdown, IOption } from "../../../../../../components/inputs/select-dropdown/select-dropdown";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import CreateRmaDefaultSettingsEditorStore from "../../../../../../stores/create-rma-default-settings-editor-store";
import { SingleValue } from "react-select";

interface IProps {
    noDefaultOption: IOption;
    createRmaDefaultSettingsEditorStore: CreateRmaDefaultSettingsEditorStore | undefined;
}

const ReturnReasonSelect: React.FC<IProps> = observer(({ noDefaultOption, createRmaDefaultSettingsEditorStore }) => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';
    const settings = createRmaDefaultSettingsEditorStore?.settings;

    const reasonsListOptions = [noDefaultOption].concat(settings?.getReasonsListOptions(true) ?? []);
    const selectedReason = () => {
        if (createRmaDefaultSettingsEditorStore?.merchantReturnReasonId === null) {
            return noDefaultOption;
        }

        return settings?.findReasonOption(createRmaDefaultSettingsEditorStore?.merchantReturnReasonId);
    }

    const getReasonsListGroupedOptions = (): GroupedOption[] => {
        if (!settings) {
            return [];
        }
        return [
            {
                category: '',
                options: [noDefaultOption]
            },
            {
                category: getTranslation('CUSTOMER_FACING', pageScope),
                options: settings.getReasonsListOptions(true)
            },
            {
                category: getTranslation('INTERNAL', pageScope),
                options: settings.getReasonsListOptions(false)
            },
        ];
    };

    const onReasonChange = (v: SingleValue<IOption>) => {
        let value: number | string | null = v?.value as number | string;
        if (value === '__NULL__') {
            value = null;
        }
        createRmaDefaultSettingsEditorStore?.setReturnReason(value as number | null);
    };

    if (createRmaDefaultSettingsEditorStore?.availableReturnReasons === C_RMA_AVAILABLE_REASONS.ALL) {
        return (
            <SelectDropdownGrouped
                options={getReasonsListGroupedOptions()}
                value={selectedReason()}
                onChange={onReasonChange}
                isSearchable={true}
            />
        );
    }

    return (
        <SelectDropdown
            options={reasonsListOptions}
            value={selectedReason()}
            onChange={onReasonChange}
            isSearchable={true}
        />
    );
});

export default ReturnReasonSelect;